module.exports = __webpack_public_path__ + "img/6fe380aaeaf60e92e099fd73649c2c82.png";